<template>
  <div class="uk-flex uk-flex-center">
    <div
        class="uk-width-4-5@m uk-width-2-3@l uk-article uk-card uk-card-body uk-card-default mbk_border_top_primary_5px mbk_large_box_shadow">
      <h4 class="uk-text-danger uk-text-center">{{ $t('operation_failure') }}</h4>
      <h4 v-if="error" class="uk-text-bold uk-text-center">{{ this.status }}</h4>
    </div>
  </div>
</template>

<script>
export default {
  name: "VerificationFailure",
  data() {
    return {
      status: '',
      error: false,
    }
  },
  methods: {
    check() {
      window.console.log(Object.keys(this.$route.query))
      if (this.$route.query.hasOwnProperty("Message")) {
        this.error = true;
        this.status = this.$route.query.Message
      }
    }
  },
  beforeMount() {
    this.check()
  },
}
</script>